export default "__VITE_ASSET__b15eefeb__"